import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../../hoc/Auxilliary";
import AttendanceItem from "../../../components/Parents/Attendence";

const Attendance = (props) => {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={12} sm={10} style={{ margin: "0 auto" }}>
          <AttendanceItem />
        </Grid>
      </Grid>
    </Aux>
  );
};

export default Attendance;
